<template>
  <div class="calendar-modal">
    <div class="calendar-slider-wrap">
      <div class="calendar-slider">
        <div class="slider-inner cf" :class="{'no-transition': noTransition}"
              :style="{transform: `translate3d(${translateVal}px, 0px, 0px)`}">
          <div v-for="(date, index) in dateRange" :key="index"
                class="slide" :class="{active: format(date, 'YYYY-MM-DD') === selectedDate}"
                @click="selectedDate = format(date, 'YYYY-MM-DD')">
            <p class="day">{{ format(date, 'ddd') }}</p>
            <p class="date">{{ format(date, 'DD') }} <span>{{ format(date, 'MMM') }}</span></p>
          </div>
        </div>
      </div>
      <i class="nav-btn nav-prev arrow-left-1" @click="slidePrev"></i>
      <i class="nav-btn nav-next arrow-right-3" @click="slideNext"></i>
    </div>
    <ul class="day-time cf">
      <li v-for="(part, index) in partsOfDay" :key="index"
          :class="{active: index == partOfDay}"
          @click="partOfDay = index">
        <div class="inner">
          <i class="day" :class="index"></i>
          <p>{{ $t(part.label) }}</p>
        </div>
      </li>
    </ul>
    <div class="calendar-actions">
      <a class="btn-1 light active" @click="selectNow">
        {{ $t('guide_calendar_button_now' ) }}
      </a>
      <a class="btn-1 light" @click="confirmFilter">
        {{ $t('general_ok_button') }}
      </a>
    </div>
  </div>
</template>

<script>
import DateTimeHelper from 'helpers/date'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'Calendar',
  data: function () {
    return {
      dateRange: [],
      currentDate: '',
      selectedDate: '',
      partOfDay: '',
      slide: 4,
      slideWidth: 0,
      translateVal: 0,
      noTransition: true
    }
  },
  computed: {
    ...mapState({
      partsOfDay: state => state.modal.modalData,
      calendarScrollToSelector: state => state.guide.calendarScrollToSelector
    }),
    scrollToSelector: function () {
      return '.' + this.partOfDay + '--' + this.selectedDate
    }
  },
  methods: {
    ...mapMutations([
      'TRIGGER_CALENDAR_SCROLL'
    ]),
    ...mapActions([
      'closeModal'
    ]),
    format: function (datetime, format) {
      return DateTimeHelper.format(datetime, format)
    },
    createDateRange: function () {
      this.currentDate = DateTimeHelper.nowStringLocal('YYYY-MM-DD')
      // console.log('this.currentDate', this.currentDate)

      for (let i = 7; i >= 1; i--) {
        let subtractedDay = DateTimeHelper.subtractDays(this.currentDate, i)
        let formattedSubtractedDay = this.format(subtractedDay, 'YYYY-MM-DD')
        this.dateRange.push(formattedSubtractedDay)
      }

      this.dateRange.push(this.currentDate)

      for (let i = 1; i <= 3; i++) {
        let addedDay = DateTimeHelper.addDays(this.currentDate, i)
        let formattedAddedDay = this.format(addedDay, 'YYYY-MM-DD')
        this.dateRange.push(formattedAddedDay)
      }

      // console.log('this.dateRange', this.dateRange)
    },
    selectCurrentDate: function () {
      this.selectedDate = this.currentDate
      // console.log('this.selectedDate', this.selectedDate)
    },
    setCurrentPartOfDay: function () {
      let currentTime = DateTimeHelper.nowStringLocal('HH:mm')
      // console.log('currentTime', currentTime)

      for (let i in this.partsOfDay) {
        let part = this.partsOfDay[i]
        if (currentTime >= part.timeStart && currentTime <= part.timeEnd) {
          this.partOfDay = i
          // console.log('this.partOfDay', this.partOfDay)
        }
      }
    },
    slidePrev: function () {
      if (this.slide !== 0) {
        // console.log('prev')
        this.slide--
        this.translateVal = this.translateVal + this.slideWidth
      }
    },
    slideNext: function () {
      if (this.slide !== this.dateRange.length - 7) {
        // console.log('next')
        this.slide++
        this.translateVal = this.translateVal - this.slideWidth
      }
    },
    selectNow: function () {
      this.closeModal()
      if (this.calendarScrollToSelector === '.live-event') {
        this.TRIGGER_CALENDAR_SCROLL('.event-live')
      } else {
        this.TRIGGER_CALENDAR_SCROLL('.live-event')
      }
    },
    confirmFilter: function () {
      this.handleNonExistentDay()
      this.closeModal()
      this.TRIGGER_CALENDAR_SCROLL(this.scrollToSelector)
    },
    handleNonExistentDay: function () {
      let dayExists = document.querySelector(this.scrollToSelector)
      if (!dayExists) {
        this.partOfDay = 'morning'
        this.selectedDate = this.format(DateTimeHelper.addDays(this.selectedDate, 1), 'YYYY-MM-DD')
      }
      let nextDayExists = document.querySelector(this.scrollToSelector)
      if (!nextDayExists) {
        this.partOfDay = 'evening'
        this.selectedDate = this.format(DateTimeHelper.subtractDays(this.selectedDate, 1), 'YYYY-MM-DD') + ':last-of-type'
      }
    },
    recalculatePosition: function () {
      this.slideWidth = this.$el.querySelector('.slide').offsetWidth
      this.translateVal = this.slide * this.slideWidth * -1
      // console.log('slide: ' + this.slide, 'slide: ' + this.slideWidth, 'slide: ' + this.translateVal)
      setTimeout(() => {
        if (this.noTransition) {
          this.noTransition = false
        }
      })
    }
  },
  created: function () {
    this.createDateRange()
    this.selectCurrentDate()
    this.setCurrentPartOfDay()
  },
  mounted: function () {
    this.recalculatePosition()
    window.addEventListener('resize', this.recalculatePosition)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.recalculatePosition)
  }
}
</script>

<style scoped lang="scss">
@import 'uc/variables';

.calendar-modal {
    position: absolute;
    top: 130px;
    left: 50%;
    width: 620px;
    // height: 480px;
    margin-left: -310px;
    background-color: #fff;
}
.calendar-slider-wrap {
    background: #f2f2f2;
}
.calendar-slider {
    width: 520px;
    margin: 0 auto;
    overflow: hidden;
}
.slider-inner {
    white-space: nowrap;
    transition: transform 300ms;

    &.no-transition {
        transition: transform 0s;
    }
}
.slide {
    display: inline-block;
    width: 74px;
    padding: 25px 0;
    outline: none !important;
    cursor: pointer;

    p {
        text-align: center;
        text-transform: uppercase;
        transition: all 300ms ease;
    }
    &:hover {
        .day,
        .date {
            color: #0095da;
        }
        .date span {
          font-weight: 500;
        }
    }
    &.active {
    .day,
    .date {
        color: #0095da;
        font-weight: 700;
    }
    .date span {
        font-weight: 500;
    }
  }
}
.day {
    margin-bottom: 5px;
    font-size: 16px;
    font-weight: 300;
    color: #323e43;
}
.date {
    margin-bottom: 0;
    font-size: 20px;
    color: #323e43;

    span {
        font-size: 10px;
    }
}

.nav-btn {
    position: absolute;
    top: 30px;
    width: 40px;
    height: 40px;
    opacity: 0.2;
    background-repeat: no-repeat;
    background-position: center center;
    transition: opacity 300ms;
    cursor: pointer;

    &:hover {
        opacity: 1;
    }
}
.nav-prev {
    left: 10px;
}
.nav-next {
    right: 10px;
}
.day-time {
    padding-left: 25px;
    padding-right: 25px;

    li {
        float: left;
        width: 25%;
        padding: 30px 0;
        text-align: center;
    }
    .inner {
        display: inline-block;
        cursor: pointer;
    }
    p {
        margin-bottom: 0;
        font-size: 13px;
        transition: color 300ms;
    }
    i {
        display: inline-block;
        width: 70px;
        height: 70px;
        position: relative;

        &:before,
        &:after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-repeat: no-repeat;
            background-size: 100%;
            transition: opacity 300ms;
        }
        &:before {
          opacity: 1;
          background-position: 0px -70px;
        }
        &:after {
          opacity: 0;
          background-position: 0px 0px;
        }
    }
    .morning {
        &:before,
        &:after {
            background-image: url(~assets/images/icons/morning.png);
        }
    }
    .afternoon {
        &:before,
        &:after {
            background-image: url(~assets/images/icons/afternoon.png);
        }
    }
    .evening {
        &:before,
        &:after {
            background-image: url(~assets/images/icons/evening.png);
        }
    }
    .lateNight {
        &:before,
        &:after {
            background-image: url(~assets/images/icons/late-night.png);
        }
    }
    .inner:hover,
    li.active .inner {
        p {
            color: #0095da;
        }
        i:after {
            opacity: 1;
        }
    }
}
.calendar-actions {
    text-align: center;
    padding: 16px 40px 16px 30px;
    border-top: 1px solid #e5e5e5;
}
.btn-1 {
    display: inline-block;
    min-width: 75px;
    margin-left: 10px;
    padding: 7px 20px 9px;
    font-size: 13px;
    border-radius: 4px;
    box-shadow: 0 0 20px 5px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
        color: rgb(0, 149, 218);
    }
    &:active,
    &.active {
        background: linear-gradient(#00acdf 0%, #00679b 100%);
        color: #ffffff;
        transition: all 0s ease;
    }
}

@media only screen and (min-width: $breakpoint3) {
    .calendar-modal {
        width: 870px;
        top: 230px;
        margin-left: -410px;
    }
    .calendar-slider {
        width: 700px;
    }
    .slide {
        width: 100px;
        padding: 30px 0;
    }
    .day {
        font-size: 22px;
        margin-bottom: 5px;
    }
    .date {
        font-size: 28px;

        span {
          font-size: 14px;
        }
    }
    .nav-btn {
        width: 50px;
        height: 60px;
        background-size: 20px;
    }
    .day-time {
        padding-left: 45px;
        padding-right: 45px;

        li {
            padding: 40px 0;
        }
        p {
            font-size: 16px;
        }
        i {
            width: 100px;
            height: 100px;

            &:before {
                background-position: 0px -100px;
            }
        }
    }
    .calendar-actions {
        padding: 26px 40px 26px 15px;
    }
    .btn-1 {
        min-width: 110px;
        margin-left: 25px;
        font-size: 18px;
    }
}
</style>



// WEBPACK FOOTER //
// src/containers/sections/Guide/Calendar.vue